import type { VisitorSubmitMode } from "./catalogueCommerceClient";

export type VisitorOrderRecord = {
  id: string;
  submittedAtIso: string;
  catalogueId: string;
  mode: VisitorSubmitMode;
  cartLines: unknown[];
  shortlistLines: unknown[];
  /** Snapshot at submit time (for invoice display). */
  clientName?: string;
  clientPhone?: string;
  clientEmail?: string;
};

function storageKey(visitorId: string): string {
  return `hkp-visitor-orders:${visitorId}`;
}

export function loadVisitorOrders(visitorId: string): VisitorOrderRecord[] {
  if (!visitorId) return [];
  try {
    const raw = localStorage.getItem(storageKey(visitorId));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as VisitorOrderRecord[]) : [];
  } catch {
    return [];
  }
}

export function appendVisitorOrder(visitorId: string, rec: Omit<VisitorOrderRecord, "id" | "submittedAtIso">): void {
  const id =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `ord-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  const submittedAtIso = new Date().toISOString();
  const next: VisitorOrderRecord = {
    id,
    submittedAtIso,
    catalogueId: rec.catalogueId,
    mode: rec.mode,
    cartLines: Array.isArray(rec.cartLines) ? rec.cartLines : [],
    shortlistLines: Array.isArray(rec.shortlistLines) ? rec.shortlistLines : [],
    clientName: rec.clientName,
    clientPhone: rec.clientPhone,
    clientEmail: rec.clientEmail,
  };
  const prev = loadVisitorOrders(visitorId);
  localStorage.setItem(storageKey(visitorId), JSON.stringify([next, ...prev].slice(0, 50)));
}
